import "./wdyr";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./pages/App";
import "./index.css";
import "./i18n";
import "react-toastify/dist/ReactToastify.css";
import config from "./amplifyconfiguration.json";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "store";
import Loading from "components/Molecules/Loading";
import appConfig from "appConfig";

Amplify.configure(config);

if (!appConfig.IS_DEV) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
